import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";
import { AuthProvider } from "./auth/AuthContext";
import { CartProvider } from "./cart/CartContext";
import { SiteConfigProvider } from "./config/SiteConfigProvider";
import App from "./app/App";
import "./i18n/i18n";
import "./styles/index.css";

// Firma sviluppo — discreta, premium, stile Granborgo.
console.log(
  "%cGranborgo\n%cAndrea Inzaghi%c  ·  develop con love",
  "color:#1C4B3B;font-family:Georgia,'Playfair Display',serif;font-weight:600;font-size:17px;letter-spacing:2px;line-height:2;",
  "color:#1C4B3B;font-family:system-ui,sans-serif;font-weight:600;font-size:11px;letter-spacing:0.6px;",
  "color:#9aa39e;font-family:system-ui,sans-serif;font-size:11px;letter-spacing:0.4px;",
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ParallaxProvider>
        <SiteConfigProvider>
          <AuthProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </AuthProvider>
        </SiteConfigProvider>
      </ParallaxProvider>
    </BrowserRouter>
  </StrictMode>,
);
